export default __webpack_public_path__ + "static/media/buyCable.6e13ce0a.svg";